<div class="row">
    <div class="col-8">
        <rask-input label="Namn"
            class="w-100"
            [maxlength]="arbetsorderNamnMaxLength"
            [(ngModel)]="arbetsorder.namn"
            (change)="arbetsorderNamnUpdated()"
            [disabled]="true"
            [rule]="validationContext.current.arbetsordernamn"></rask-input>
    </div>
    @if (!isCkArbetsorder()) {
    <div class="col-4">
        <rask-textmultiline label="LKD">
            <div>{{arbetsorder.lkd}}</div>
        </rask-textmultiline>
    </div>
    }
</div>
<div class="row mt-3">
    @if (!isCkArbetsorder()) {
    <div class="col-4">
        @if (isSchemalagd()) {
        <rask-textmultiline label="Länk till Prolog">
            <a href="{{prologLink()}}" target="_blank">
                {{arbetsorder.beteckning}}</a>
        </rask-textmultiline>
        }
    </div>
    }
    @if (!isCkArbetsorder()) {
    <div class="col-8">
        <rask-textmultiline
            label="Hämtplats"
            class="w-100">
            <div>{{arbetsorder.hamtplats}}</div>
        </rask-textmultiline>
    </div>
    }
</div>
<div class="row">
    @if (!isEgenTerminal()) {
    <div class="col-8">
        <rask-textmultiline
            label="Leverantör"
            class="w-100">
            <div>{{arbetsorder.ckLeverantor}}</div>
        </rask-textmultiline>
    </div>
    }
</div>
<div class="row">
    @if (uppdragsListaAktiv && !isCkArbetsorder()) {
    <div class="col-4">
        <rask-selector
            label="Uppdrag"
            [values]="uppdragsListaAktiv"
            [disabled]="!isDetailEditable()"
            [reverseLookup]="true"
            [ngModel]="arbetsorder.uppdragId"
            [formatter]="uppdragFormatter"
            [viewSelectedFormatter]="uppdragSelectedFormatter"
            placeholder="Välj uppdrag"
            [viewFormatter]="uppdragViewFormatter"
            (ngModelChange)="arbetsorderUppdragUpdated($event)"
            [addModelValueWhenMissing]="getUppdragInitialValue"
            infoText="För Viol3 används uppdrag endast internt på Sveaskog. Om du har behov av andra koder vid extraordinär händelse, kontakta förvaltningen.">
        </rask-selector>
    </div>
    }
    @if (!isCkArbetsorder()) {
    <div class="col-4">
        <rask-input
            label="Virket märkt"
            [(ngModel)]="arbetsorder.virketMarkt"
            (change)="arbetsorderVirketMarktUpdated()"
            [disabled]="!isDetailEditableAfterSend()"
            [maxlength]="10"
            [rule]="validationContext.current.arbetsorderVirketMarkt"></rask-input>
    </div>
    }
    @if (arbetsorder.viol3) {
    <div class="col-4">
        <rask-textmultiline label="VIOL3-Status">
            <rask-viol3status-indicator
                [arbetsorderid]="arbetsorder.id">
            </rask-viol3status-indicator>
        </rask-textmultiline>
    </div>
    }
</div>
@if (isImport()) {
<div class="row">
    <div class="col-4">
        <rask-input
            label="Båt-id"
            [(ngModel)]="arbetsorder.batId"
            (change)="batIdUpdated()"
            [disabled]="!isDetailEditableAfterSend()"
            [maxlength]="10"></rask-input>
    </div>
</div>
}
@if (!isCkArbetsorder()) {
<div class="row mt-3">
    <div class="col-5">
        <rask-selector
            label="Ansvarig för avverkning"
            [disabled]="!isDetailEditable()"
            aid="ansvarigAvverkningsledare"
            [debounceTime]="300"
            [minCharacters]="3"
            [reverseLookup]="false"
            [ngModel]="avverkningsAnsvarig"
            (ngModelChange)="selectedAvverkningsledare($event)"
            [formatter]="ansvarigFormatter"
            [viewSelectedFormatter]="ansvarigSelectedFormatter"
            placeholder="Ange minst tre tecken"
            [search]="searchForAnsvarigAvverningsledareTypeAhead"
            [viewFormatter]="ansvarigViewFormatter">
        </rask-selector>
    </div>
    <div class="col-2">
    </div>
    @if (canAvslutaViol3Avtalsobjekt()) {
    <div class="col-5">
        <rask-arbetsorder-viol3-makulera-button
            [arbetsorder]="arbetsorder">
        </rask-arbetsorder-viol3-makulera-button>
    </div>
    }
</div>
}